import { createContext, useContext } from "react";

export const AdminStatisticsContext = createContext(null);

export const useAdminStatistics = () => {
  return useContext(AdminStatisticsContext);
};
